import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Scale, Building, Server, Copyright, ShieldCheck, Cookie } from 'lucide-react';

const LegalSection = ({ icon: Icon, title, children }) => (
  <div className="mb-12">
    <div className="flex items-center gap-3 mb-6">
      <div className="w-10 h-10 rounded-xl bg-[#3dd3ee]/10 flex items-center justify-center">
        <Icon className="w-5 h-5 text-[#3dd3ee]" />
      </div>
      <h2 className="text-2xl font-bold text-white">{title}</h2>
    </div>
    <div className="text-white/70 space-y-4 pl-13">
      {children}
    </div>
  </div>
);

const LegalPage = () => {
  return (
    <div className="min-h-screen bg-[#0a0a0b]">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-16 overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#3dd3ee]/10 rounded-full blur-[150px]" />
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-[#c8aff0]/10 rounded-full blur-[150px]" />
        </div>
        
        <div className="relative max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <span className="inline-flex items-center gap-2 px-4 py-2 bg-white/5 backdrop-blur-xl rounded-full border border-white/10 text-sm font-medium text-white/70 mb-6">
            <Scale className="w-4 h-4 text-[#fad24b]" />
            Informations légales
          </span>
          <h1 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Mentions{' '}
            <span className="bg-clip-text text-transparent" style={{ backgroundImage: 'linear-gradient(135deg, #3dd3ee, #c8aff0)' }}>
              légales
            </span>
          </h1>
        </div>
      </section>

      {/* Content */}
      <section className="relative pb-24">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <div className="bg-white/5 backdrop-blur-sm rounded-3xl p-8 lg:p-12 border border-white/10">
            
            {/* Éditeur du site */}
            <LegalSection icon={Building} title="Éditeur du site">
              <p>
                Le présent site est édité par <strong className="text-white">Indexcore</strong>, entité de la société <strong className="text-white">Indexpresse</strong>.
              </p>
              <div className="bg-white/5 rounded-xl p-6 space-y-2">
                <p><span className="text-white/50">Raison sociale :</span> <span className="text-white">Indexpresse</span></p>
                <p><span className="text-white/50">Forme juridique :</span> <span className="text-white">Société par actions simplifiée (SAS)</span></p>
                <p><span className="text-white/50">Numéro SIREN :</span> <span className="text-white">382 758 589</span></p>
              </div>
              <div className="bg-white/5 rounded-xl p-6">
                <p className="text-white/50 mb-2">Siège social :</p>
                <p className="text-white">Indexpresse – Le Spring</p>
                <p className="text-white">96 rue Félix Esclangon</p>
                <p className="text-white">38000 Grenoble – France</p>
              </div>
              <p>
                <span className="text-white/50">Représentant légal :</span>{' '}
                <span className="text-white">Aymar Monnoyeur</span>
              </p>
            </LegalSection>

            {/* Hébergement */}
            <LegalSection icon={Server} title="Hébergement">
              <p>
                Le site est hébergé par un prestataire tiers.
              </p>
              <p>
                Les informations relatives à l'hébergeur peuvent être communiquées sur simple demande.
              </p>
            </LegalSection>

            {/* Propriété intellectuelle */}
            <LegalSection icon={Copyright} title="Propriété intellectuelle">
              <p>
                L'ensemble des contenus présents sur ce site (textes, images, graphismes, logos, icônes, vidéos, architecture, contenus IA, etc.) est protégé par le droit de la propriété intellectuelle et est la propriété exclusive d'Indexpresse, sauf mention contraire.
              </p>
              <p>
                Toute reproduction, représentation, modification, publication ou adaptation, totale ou partielle, des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite sans l'autorisation écrite préalable d'Indexpresse.
              </p>
            </LegalSection>

            {/* Responsabilité */}
            <LegalSection icon={Scale} title="Responsabilité">
              <p>
                Les informations diffusées sur ce site sont fournies à titre indicatif.
              </p>
              <p>
                Indexpresse s'efforce d'assurer l'exactitude et la mise à jour des informations, mais ne saurait être tenue responsable des omissions, inexactitudes ou carences dans la mise à jour.
              </p>
              <p>
                L'utilisation des informations et contenus disponibles sur l'ensemble du site ne saurait engager la responsabilité d'Indexpresse, à quelque titre que ce soit.
              </p>
            </LegalSection>

            {/* Données personnelles */}
            <LegalSection icon={ShieldCheck} title="Données personnelles">
              <p>
                Le site peut être amené à collecter des données personnelles via ses formulaires de contact.
              </p>
              <p>
                Les données collectées sont destinées exclusivement à Indexpresse et ne sont en aucun cas cédées ou vendues à des tiers.
              </p>
              <p>
                Conformément à la réglementation applicable (RGPD – Règlement UE 2016/679), vous disposez d'un droit d'accès, de rectification, d'effacement et de limitation du traitement de vos données.
              </p>
              <p>
                Toute demande relative à l'exercice de ces droits peut être adressée par courrier à l'adresse du siège social mentionnée ci-dessus.
              </p>
            </LegalSection>

            {/* Cookies */}
            <LegalSection icon={Cookie} title="Cookies">
              <p>
                Le site peut utiliser des cookies à des fins de mesure d'audience ou d'amélioration de l'expérience utilisateur.
              </p>
              <p>
                Vous pouvez à tout moment configurer votre navigateur pour refuser les cookies.
              </p>
            </LegalSection>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default LegalPage;
